// extracted by mini-css-extract-plugin
export default {"root":"uhWS4b","bg":"dfnqE5"};